import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Field from '../components/Field';
import CardService from '../service/CardService';
import { Speciality } from '../type/speciality';

export default () => {
  const [accept, setAccept] = useState(true);
  const [selectedSpecs, setSelectedSpecs] = useState([]);
  const [fields, setFields] = useState<any[]>([]);
  const [specialities, setSpecialities] = useState<Speciality[]>([]);

  const local = CardService.isLocal();

  const history = useHistory();

  const getSpecialityTitle = (speciality: Speciality) => `${speciality.name} (${speciality.studyForm}, ${speciality.financing})`;

  const validate = () => fields.filter((f) => f.required && f.type.id !== 12).every((f) => f.value !== undefined && f.value !== '');

  const saveForm = () => {
    if (!validate()) {
      alert('Поля, отмеченные звездочкой (*) обязательны для заполнения');

      return;
    }

    if (selectedSpecs.length === 0) {
      alert('Укажите, пожалуйста, специальности/профессии, на которые хотите подать заявление. Расположены вверху страницы.');

      return;
    }

    if (local) {
      CardService.save(-1, fields, selectedSpecs.map((s) => ({ id: s }))).then(() => {
        alert('Ваша анкета успешно сохранена! Подойдите, пожалуйста, к сотрудникам приемной комиссии.');
        window.location.reload();
      });
    }

    const id = localStorage.getItem('user');
    CardService.save(Number(id), fields, selectedSpecs.map((s) => ({ id: s }))).then(() => {
      alert('Ваша анкета успешно сохранена! Ожидайте, пожалуйста, ответа на почту от сотрудников приемной комиссии.');
      CardService.logout();
      history.push('/registration');
    });
  };

  useEffect(() => {
    CardService.getFields().then((response) => {
      setFields(response.data.map((item: any) => ({ ...item, error: item.required })));
    });
    CardService.getSpecialities().then((response) => {
      const specs = response.data;
      specs.sort((a: { ord: number; }, b: { ord: number; }) => (a.ord > b.ord ? -1 : 1));
      setSpecialities(response.data);
    });
  }, []);

  // @ts-ignore
  return (
    <Paper>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3} />
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" gutterBottom>
            Анкета
          </Typography>
          <Typography variant="body1" gutterBottom color="primary">
            Пожалуйста, заполните все обязательные поля, отмеченные звёздочкой (*).
          </Typography>
          <FormControl fullWidth required>
            <InputLabel error={selectedSpecs.length === 0}>
              Выбранные специальности/профессии:
            </InputLabel>
            <Select
              fullWidth
              value={selectedSpecs}
              multiple
              error={selectedSpecs.length === 0}
              // @ts-ignore
              onChange={(event) => setSelectedSpecs(event.target.value)}
              // @ts-ignore
              renderValue={(selected: number[]) => specialities.filter((s) => selected.indexOf(s.id) >= 0).map((s) => s.name).join(', ')}
            >
              {
              specialities.map((s) => (
                <MenuItem key={s.id} value={s.id}>
                  <Checkbox
                    // @ts-ignore
                    checked={selectedSpecs.indexOf(s.id) >= 0}
                  />
                  <ListItemText primary={getSpecialityTitle(s)} />
                </MenuItem>
              ))
            }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} />
      </Grid>
      {
        fields.map((field) => (
          <Field
            key={field.id}
            field={field}
            onChange={(value: any) => {
              setFields((prev) => {
                const items = [...prev];
                const itemIndex = items.findIndex((i) => i.id === field.id);
                items[itemIndex].value = value;
                items[itemIndex].error = field.required && !value;
                return items;
              });
            }}
            onFileUpload={() => {
              setFields((prev) => {
                const items = [...prev];
                const itemIndex = items.findIndex((i) => i.id === field.id);
                items[itemIndex].fileUploaded = true;
                return items;
              });
            }}
          />
        ))
      }
      <Grid
        container
        spacing={3}
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={8}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={accept}
                onChange={(e) => setAccept(e.target.checked)}
                name="checkedB"
                color="primary"
              />
            )}
            label="В соответствии с Федеральным Законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» даю
          согласие на обработку моих персональных данных, а именно: анкетных и биографических, об
          образовании, о составе семьи, о наличии судимости, адрес места жительства,
          мобильный телефон, место учебы или работы членов семьи. Данные предоставляются
          для обработки в целях соблюдения законов, обеспечения личной безопасности
          и организации процесса образования. Я подтверждаю, что ознакомлен с документами
          образовательного учреждения, устанавливающими порядок обработки персональных данных,
          а также с моими правами и обязанностями в этой области. Согласие вступает в силу
          со дня его подписания и действует в течение всего периода обучения.
          Согласие может быть отозвано в любое время на основании моего письменного заявления. *"
          />

        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={4}>
          <Button variant="contained" color="primary" onClick={saveForm}>Сохранить</Button>
          <Button onClick={() => CardService.logout()}>Выход</Button>
        </Grid>
      </Grid>
    </Paper>
  );
};
